// RUSSISCH FIX - Force Language Change
import i18n from './i18n.js';

// Funktion zum Erzwingen der Russisch-Sprache
export const forceRussianLanguage = () => {
  // 1. Setze Sprache direkt
  i18n.changeLanguage('ru');
  
  // 2. Speichere in LocalStorage
  localStorage.setItem('i18nextLng', 'ru');
  
  // 3. Setze HTML lang attribute
  document.documentElement.lang = 'ru';
  
  // 5. Seite neu laden (falls nötig)
  setTimeout(() => {
    window.location.reload();
  }, 100);
};

// Automatische Erkennung und Korrektur
export const fixRussianLanguage = () => {
  const currentLang = i18n.language;
  const browserLang = navigator.language || navigator.userLanguage;
  
  // Wenn Browser Russisch ist, aber aktuelle Sprache nicht
  if (browserLang.startsWith('ru') && currentLang !== 'ru') {
    forceRussianLanguage();
  }
};

export default { forceRussianLanguage, fixRussianLanguage };
